import { isDefined as t } from "./types3.mjs";
const w = async (e) => {
  const r = await e.arrayBuffer(), o = new Blob([new Uint8Array(r)], {
    type: e.type
  }), n = document.createElement("a");
  n.href = window.URL.createObjectURL(o), n.download = e.name, n.click(), window.URL.revokeObjectURL(n.href);
}, c = async (e) => {
  if (!t(e))
    return;
  const r = await e.arrayBuffer(), o = new Blob([new Uint8Array(r)], {
    type: e.type
  });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(r, e.name);
    return;
  }
  const n = URL.createObjectURL(o);
  if (navigator.userAgent.indexOf("Chrome") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1) {
    const a = window.open(n, "_blank");
    a && a.focus();
  } else
    window.location.href = n;
};
export {
  w as downloadFile,
  c as previewFile
};
//# sourceMappingURL=file.mjs.map
